(() => {
  class TabbedContent extends HTMLElement {
    constructor() {
      super();

      this.USP_CLASS = "usp-tabs__slideshow--hidden";
      this.BUTTON_CLASS = "carousel__button--hidden";
      this.NAVIGATION_CLASS = "carousel__navigation--hidden";
      this.controlWrappers = this.querySelectorAll("[data-tab-index]");

      subscribe(PUB_SUB_EVENTS.tabChange, data => this.tabClick(data));
    }

    /**
     * Handles tab click events
     * @param {Object} param0 - The event data object.
     * @param {string} param0.tab - The active tab index.
     * @param {HTMLElement} param0.wrapper - The wrapper element that triggered the event.
     */
    tabClick({ tab: activeTab, wrapper }) {
      if (wrapper !== this) return;

      this.controlWrappers.forEach(controlWrapper => {
        const index = controlWrapper.dataset.tabIndex;
        const elementType = controlWrapper.dataset.element?.toUpperCase();

        activeTab === index
          ? controlWrapper.classList.remove(this[`${elementType}_CLASS`])
          : controlWrapper.classList.add(this[`${elementType}_CLASS`]);
      });
    }
  }

  if (!customElements.get("tabbed-content")) {
    customElements.define("tabbed-content", TabbedContent);
  }
})();